module.exports = __webpack_public_path__ + "img/icon_huodong@2x.3b93f519.png";